<template>
  <Page :title="title">
    <div class="van-collapse-item__content">
                            <!-- 课程名称 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程名称：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="pullList[0]['name']"
                            placeholder="请输入课程名称"
                            oninput="if(value.length>100)value=value.slice(0,100)"
                        >
                    </div>
                    <!-- 课程类型 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(1)">
                            {{pullList[1]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 导师类型 -->                    
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">导师类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(2)">
                            {{pullList[2]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div> 
                     <!-- 培训导师 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">培训导师：</div>
                        <div class="pull-down-selects" data-id="10" >
                        <input
                            type="text"
                            class="inputs"
                            v-model="pullList[3]['name']"
                            placeholder="请输入培训导师"
                            oninput="if(value.length>50)value=value.slice(0,50)"
                        >                            
                        </div>
                    </div> 
                    <!-- 课程日期 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one titles" >课程日期：</div>
                        <div class="birthday-flex-style-one" @click="downSelections(4)">
                            {{pullList[4]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                        <div class="birthday-flex-style-one" @click="downSelections(5)">
                            {{pullList[5]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                    <!-- 日期列表 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active"  
                    v-for="(item,index)  in  U_RangeTimeList" v-bind:key="index"  
                    v-if="item.deleteFlag!=1" >
                        <!-- <div class="birthday-flex-style-one">课程日期</div> -->
                        <div class="birthday-flex-style-one  birthday-flex-style-one-ative" @click="downTimetions(index,1)">
                            {{item.date||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                        <div class="birthday-flex-style-one birthday-flex-style-one-ative" @click="downTimetions(index,2)">
                            {{item.timeFrame==1?'上午':item.timeFrame==2?'下午':item.timeFrame==3?'全天':'上午'||'上午'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                        <div class="delete-flex" @click="deletes(index)">
                          <!-- delete.png -->
                          <img :src="require('@/assets/img/delete.png')" class="delete" alt="">
                        </div>
                    </div>
                    <!-- 添加日期 -->
                    <div class="flex itemCenter cell-list-item  center-flex" @click="addDate" >
                               +
                    </div>  

                    <!-- 国家 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">国家：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(6)">
                            {{pullList[6]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>  
                    <!-- 城市 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">城市：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(7)">
                            {{pullList[7]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div> 
                    <!-- 地点 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">地点：</div>
                        <textarea
                            type="text"
                            class="inputs"
                            v-model="pullList[8]['name']"
                            placeholder="请输入详情地址"
                            maxlength="254"
                        />
                    </div>
                    <!-- 学员类型 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">学员类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(9)">
                            {{pullList[9]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div> 
                            <!-- 学员人数 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">学员人数：</div>
                        <input
                            type="number"
                            class="inputs"
                            v-model="pullList[10]['name']"
                            placeholder="请输入学员人数"
                            oninput="if(value.length>15)value=value.slice(0,15)"
                            @blur="totals"
                            @keyup.enter="totals"
                        >
                    </div>
                      <!-- 课程费用币种： -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程费用币种：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(11)">
                            {{pullList[11]['name']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div> 
                            <!-- 单人费用： -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">单人费用：</div>
                        <input
                            type="number"
                            class="inputs"
                            v-model="pullList[12]['name']"
                            placeholder="请输入单人费用"
                            oninput="if(value.length>15)value=value.slice(0,15)"
                             @blur="totals"
                             @keyup.enter="totals"
                        >
                    </div>
                            <!-- 费用合计： -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">费用合计：</div>
                        <input
                            type="number"
                            class="inputs"
                            v-model="pullList[13]['name']"
                            placeholder="请输入费用合计"
                            oninput="if(value.length>15)value=value.slice(0,15)"
                        >
                    </div>


                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">提交作品：</div>
                        <div  class="radio-flex">
                        <van-radio-group v-model="pullList[14]['value']" class="neededShow-flex">
                          <van-radio name="1"   >需要
                                          <img
                                          slot="icon"
                                          slot-scope="props"
                                          :src="props.checked ? Icon[0]: Icon[1]"
                                          class="radioImg"
                                        > 
                          </van-radio>
                          <van-radio name="0"  >不需要
                                          <img
                                          slot="icon"
                                          slot-scope="props"
                                          :src="props.checked ? Icon[0]: Icon[1]"
                                          class="radioImg"
                                        > 
                          </van-radio>                        
                        </van-radio-group>
                        </div>
                    </div>
      <div class="quillcontent">
        <van-uploader :after-read="onRead" accept=""    multiple>
        <van-icon name="photograph" />
         </van-uploader>
        <!-- 富文本 -->
        <van-cell title="课程介绍" size="large"/>
        <quill-editor
           data-placeholder=""
          :content="content"
          class="ql_editor"
          ref="QuillEditor"
          :options="editorOption"
         @change="onEditorChange($event)"
          
        ></quill-editor>
      </div>

    
            <!-- 下拉筛选 -->
            <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
                <van-picker
                    show-toolbar
                    title=""
                    :columns="downSelection"
                    @cancel="onCancelCode"
                    @confirm="onConfirmCode"
                     :value-key="'name'"
                    class="van-picker-li"
                />
            </van-popup>
            <!-- 时间筛选 -->
            <van-popup v-model="showTimeSelection" position="bottom" :overlay="true">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                @cancel="onCancelTime"
                @confirm="onConfirmTime"
                :min-date="minDate"
              />
            </van-popup>
           

                       <!-- 下拉筛选 -->
            <van-popup v-model="showDateSelection" position="bottom" :overlay="true">
                <van-picker
                    show-toolbar
                    title=""
                    :columns="downSelection1"
                    @cancel="onCancelCode1"
                    @confirm="onConfirmCode1"
                     :value-key="'name'"
                    class="van-picker-li"
                />
            </van-popup>
            <!-- 时间筛选 -->
            <van-popup v-model="showDateTime" position="bottom" :overlay="true">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                @cancel="onCancelTime1"
                @confirm="onConfirmTime1"
                :min-date="minDate"
              />
            </van-popup>

    </div>
  <div class="returnTo">
    <img :src="require('@/assets/return.png')"   @click="returnTo"  class="back"  alt="">
  </div>    
        <div class="botton_but">
             <van-button size="small" class="addbutton" type="danger" @click="addCurriculum">保存</van-button>
        </div>
  </Page>
</template>
<script>
//销售用户id
let dictionary = {},
  findContuny;
    // 工具栏配置
    const toolbarOptions = [
      ['bold', 'italic', 'underline',{ 'color': [] }, { 'background': [] }],        // toggled buttons
      ['image',{ 'list': 'ordered'}, { 'list': 'bullet' },{ 'align': [] }],
    ]


import { Toast } from "vant";
import $ from "jquery";
import imageCompression from 'browser-image-compression';

export default {
  name: "addCurriculum",
  data() {
    return {
    editorOption: {                
            modules: {
                toolbar: {
                    container: toolbarOptions,  // 工具栏
                    handlers: {
                        'image': function (value) {
                            if (value) {
                                // 调用iview图片上传
                                document.querySelector('.van-uploader__input').click()
                            } else {
                                this.quill.format('image', false);
                            }
                        }
                    }
                },
                ImageResize : {
                  displaySize: true
                }
            }
        },
      minDate: new Date(),
      currentDate: new Date(),
      text_center: true,
      title: "新增课程",
      message: "",
      autosize: { maxHeight: 100, minHeight: 20 },
      placeholder: "请输入",
      neededShow: "1",
      attribute: {
        salesId: "", //销售用户id
        courseId: "", //课程id
        courseName: "", //课程名称
        courseType: "", //课程类型
        teacherId: "", //培训导师
        rangeTime: "", //课程日期范围
        country: "", //国家
        city: "", //城市
        address: "", //地点
        studentType: "", //学员类型
        studentCnt: "", //学员人数
        currency: "", //币种
        price: "", //单人费用
        amount: "", //费用合计
        neededShow: "", //提交作品
        descption: "" //课程介绍
      },
      curriculumTime: [{ time: "2018-10-10", M: "上午" }],
      editor: "", //富文本编辑框
      content: "",
      memberList: [], //学员列表
      calendarList: [], //课程时间
      startDate: null,
      endDate: null, //结束日期
      timeShow: false, // 时间展示
      rangeTimeindex: 0,
      


      ///////////////////////////-   重置  -////////////////////////////////

    // 字典表查询code
    codeList:['teacherType','StudentType','Classes','Country','CourseCity','Currency','U_RangeTime'],
    teacherTypeList:[], //导师类型
    studentTypeList:[], //学员类型  
    courseTypeList:[],  //全部课程
    CountryList:[],     //国家
    CourseCityList:[],  //城市
    CurrencyList:[],    //币种
    supervisorList:[],  //培训导师 
    NeedList:[{name:"全部",value:"0"},{name:"需要",value:"1"},{name:"不需要",value:"2"},],        //提交作品

    courseType:"",   //课程类型
    teacherType:"",  //导师类型
    studentType:"",  //学员类型
    courseName:"",   //课程名称
    teacherId:"",    //培训导师
    startDate:"",    //课程开始日期
    endDate:"",      //课程结果日期
    city:"",         //城市
    startStudentCnt:"",  //学员开始人数
    endStudentCnt:"",    //学员结束人数
    currency:"",         //课程费用币种
    startPrice:"",       //单人费用开始费用
    endPrice:"",         //单人费用结束费用
    startAmount:"",      //费用合计开始
    endAmount:"",        //费用合计结束
    neededShow:"",       //是否需要提交作品
    address:"",          //地点
    country:"",          //国家
    pullList: [
        {name:"",val:""}, //课程名称
        {name:"",val:""}, //课程类型
        {name:"",val:""}, //导师类型
        {name:"",val:""}, //培训导师
        {name:"",val:""}, //课程开始日期
        {name:"",val:""}, //课程结果日期
        {name:"",val:""}, //国家
        {name:"",val:""}, //城市
        {name:"",val:""}, //地点
        {name:"",val:""}, //学员类型
        {name:"",val:""}, //学员开始人数
        {name:"人民币",val:"",value:"10"}, //课程费用币种
        {name:"",val:""}, //单人费用开始费用
        {name:"",val:""}, //费用合计开始  
        {name:"",val:"",value:"0"}, //是否需要提交作品      
      ], 
    showDownSelection:false ,  //下拉菜单展示
    showTimeSelection:false,   //下拉时间栏
    showDateSelection:false,   // 日期新增列表 下拉菜单展示
    showDateTime:false,        // 日期新增列表 下拉时间栏
    downSelection:[],          //下拉菜单列表数据
    downSelectionVal:0,        //下拉菜单当前索引
    U_RangeTime:[],            //筛选列表
    U_RangeTimeList:[],         //新增时间列表
    downTimeVal:0,             //时间列表下拉筛选
    downTimeType:0,            //点击新增时间列表判断 日期 和 时间段        
    downSelection1:[],         // 新增时间 下拉列表
    courseId:"",               // 课程ID 来判断是否是编辑页面 默认为新增页面
    Qcontent:"",               //富文本
    Icon:[ require('@/assets/Sc.png'),require('@/assets/Sn.png')]  
    };
  },
  methods: {


   /**
     * 
     * =====================================================================================
     *                                        重置
     * =====================================================================================
     * 
     */
  // 图片上传返回
  async onRead(file){
     var fileSrc = file.file;

     var isImg = this.$wxuserUtil.validateIsImg(fileSrc);
     if(!isImg){
       return;
     }

     let lastFile = await imageCompression(fileSrc,this.$wxuserUtil.compressImgOptions);

      var formData = new FormData()
      formData.append('salesId',this.$wxuserUtil.getUserId())
      formData.append('file',lastFile)
      return  this.$api.uploadFile(formData).then(response=>{
        if(response.success==true){
          let quill = this.$refs.QuillEditor.quill
         // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片，res为服务器返回的图片链接地址
          quill.insertEmbed(length, 'image',this.$http+'upload/'+ response.data.fileName)
          // 调整光标到最后
          quill.setSelection(length + 1)
        }else{
          this.$topTip(this,`图片上传失败,${response.msg}`);
        }
      })
  },  
  //计算最大值最小资
  MaxMin(data){
    let list=[];
    for(let i=0;i<data.length;i++){
      list.push(this.moment(data[i]['date'],'YYYY-MM-DD'))
    }
      this.pullList[4]['name']=this.moment.min(list)['_i'];
      this.pullList[5]['name']=this.moment.max(list)['_i'];
  },
    // 新增日期
    addDate(){     
         this.U_RangeTimeList.push({"date": "","timeFrame": "","courseCalendarId":"","deleteFlag":'0'})

    },
   onCancelCode1(){
       this.showDateSelection=false;
   },
   onConfirmCode1(val){
       console.log("确认框",val)
       this.U_RangeTimeList[this.downTimeVal]['timeFrame']=val.value?val.value:1;
       this.showDateSelection=false;
       console.log(this.U_RangeTimeList,'时间列表')
   },
   onCancelTime1(){
       this.showDateTime=false;
   },
   onConfirmTime1(val){
       console.log("时间确认返回")
       this.U_RangeTimeList[this.downTimeVal]['date']=this.$time(val);
       this.showDateTime=false;
       this.MaxMin(this.U_RangeTimeList);
   },
    //添加课程
   addCurriculum() {
     let $data   =  this.pullList;

      if($data[0]['name']==''||$data[0]['name']==null){
       this.$title("课程名称不能为空")
       return;
      }
      if($data[1]['value']==''||$data[1]['value']==null){
       this.$title("请选择课程类型")
       return;
      }
      if($data[2]['value']==''||$data[2]['value']==null){
       this.$title("请选择导师类型")
       return;
      }
      if($data[3]['name']==''||$data[3]['name']==null){
       this.$title("请输入培训导师")
       return;
      } 
           
      if($data[4]['name']==''||$data[5]['name']==''){
       this.$title("请选择日期")
       return;
      }else{
        if(this.compareDate($data[4]['name'],$data[5]['name'])==false){
          this.$title("开始日期大于结束日期")
          return;
        }
      }

      if(this.U_RangeTimeList.length==0){
       this.$title("请添加课程日期")
       return;        
      }

      for(let o=0;o<this.U_RangeTimeList.length;o++){
            if(this.U_RangeTimeList[o]['date']==''){
                     this.$title("添加课程日期不能为空")
                     return;
            }else{
               if(this.U_RangeTimeList[o]['timeFrame']==''){
                      this.U_RangeTimeList[o]['timeFrame']=1;
               }
            }
      }

      if($data[6]['value']==''||$data[6]['value']==null){
       this.$title("请选择国家")
       return;
      } 
      if($data[7]['value']==''||$data[7]['value']==null){
       this.$title("请选择城市")
       return;
      } 
      if($data[8]['name']==''||$data[8]['name']==null){
       this.$title("请选择详细地址")
       return;
      }       
      if($data[9]['value']==''||$data[9]['value']==null){
       this.$title("请选择学员类型")
       return;
      }      
      if($data[10]['name']==''||$data[10]['name']==null){
       this.$title("学员人数不能为空")
       return;
      } 
      if($data[10]['name'].toString().indexOf('.')!=-1){
       this.$title("学员人数不能为小数")
       return;
      } 

      if($data[11]['value']==''||$data[11]['value']==null){
       this.$title("请选择费用币种")
       return;
      } 
      if($data[12]['name']==''||$data[12]['name']==null){
       this.$title("单人费用不能为空")
       return;
      } 


      if($data[13]['name']==''||$data[13]['name']==null){
       this.$title("费用合计不能为空")
       return;
      } 
      if($data[14]['value']==''||$data[14]['value']==null){
       this.$title("请选择提交作品需求")
       return;
      } 

     console.log("获取数据列表",this.pullList)
     console.log("时间列表",this.U_RangeTimeList);

     let data={}
              data['salesId']=this.$wxuserUtil.getUserId();
              data['courseId']=this.courseId?this.courseId:''
              data['courseType']=$data[1]['value'];            //课程类型
              data['teacherType']=$data[2]['value'];        //导师类型
              data['studentType']=$data[9]['value'];           //学员类型
              data['courseName']=$data[0]['name'].trim();             //课程名称
              data['teacherName']=$data[3]['name'];                     //培训导师
              data['startDate']=$data[4]['name'].trim();              //课程开始日期
              data['endDate']=$data[5]['name'].trim();                //课程结果日期
              data['city']=$data[7]['value'];                  //城市
              data['studentCnt']=$data[10]['name'];            //学员开始人数
              data['currency']=$data[11]['value'];             //课程费用币种
              data['price']=$data[12]['name'];                 //单人费用开始费用
              data['amount']=$data[13]['name'];                //费用合计开始         
              data['neededShow']=$data[14]['value'];                //是否需要提交作品
              data['address']=$data[8]['name'];                     //详细地址
              data['country']=$data[6]['value'];                     //国家
              data['deptId']=this.$wxuserUtil.getDeptId();          //门店ID
              data['timeList']= JSON.stringify(this.U_RangeTimeList);                //时间列表
              data['rangeTime']= $data[4]['name'].trim()+'/'+$data[5]['name'].trim();
              data['descption']= this.Qcontent

              this.$api.saveCourseSaves(data).then(Response=>{
             console.log("新增成功",Response)
             if(Response.success){
                 if(this.courseId){
                   this.$title("修改成功")
                  }else{
                  this.$title("新增成功")
                 }
               setTimeout(()=>{
                this.$router.push({ path: "/detailsCurriculum", query: {courseId:Response.data} });  
               },500)
             }else{
               this.$title("新增失败")
             }
     })

  },
  compareDate(checkStartDate, checkEndDate) {      
    var arys1= new Array();      
    var arys2= new Array();      
    if(checkStartDate != null && checkEndDate != null) {      
        arys1=checkStartDate.split('-');      
          var sdate=new Date(arys1[0],parseInt(arys1[1]-1),arys1[2]);      
        arys2=checkEndDate.split('-');      
        var edate=new Date(arys2[0],parseInt(arys2[1]-1),arys2[2]);      
    if(sdate > edate) {            
        return false;         
    }  else {   
        return true;      
        }   
     }      
  },



    // 拉下    确定 取消
    onCancelCode(){ this.showDownSelection=false; },  
    onConfirmCode(val){
         console.log("确定按钮",val)
         console.log("**********",this.downSelectionVal);
         console.log("----------",this.pullList[this.downSelectionVal])
         this.pullList[this.downSelectionVal]['name']=val.name;
         this.pullList[this.downSelectionVal]['value']=val.value;
         this.showDownSelection=false;
         if(this.downSelectionVal==2){
          this.getCourseTeacherInfo(this.pullList[this.downSelectionVal]['value']);
         }
    },
    // 时间    确定 取消
    onCancelTime(){ this.showTimeSelection=false; },  
    onConfirmTime(val){
           if(this.downSelectionVal!=98){
            this.pullList[this.downSelectionVal]['name']=this.$time(val);
            this.pullList[this.downSelectionVal]['value']=this.$time(val);
            this.showTimeSelection=false;
           }
    },
    downSelections(index){
      this.downSelectionVal=index;
      console.log(index,'sssss');
      if(index==1||index==2||index==3||index==6||index==7||index==9||index==11){  
        switch(index){
          case   1     :    this.downSelection=this.setCodeAlls(this.courseTypeList);break
          case   2     :    this.downSelection=this.setCodeAlls(this.teacherTypeList);break
          case   3     :    this.downSelection=this.setCodeAlls(this.supervisorList);break
          case   6     :    this.downSelection=this.setCodeAlls(this.CountryList);break
          case   7     :    this.downSelection=this.pullList[6]['value']=='10'?this.setCodeAlls(this.CourseCityList):[{value: "50", name: "其他", code: "Others", sort: -1}];break
          case   9     :    this.downSelection=this.setCodeAlls(this.studentTypeList);break
          case   11    :    this.downSelection=this.CurrencyList;break
        }
        this.showDownSelection=true;
      }else
      if(index==99){
        this.downSelection=this.U_RangeTime;
        this.showDownSelection=true;
      }else{
        this.showTimeSelection=true;
      }  
    },
    downTimetions(index,ID){
        this.downTimeType=ID;
        this.downTimeVal=index;
        if(ID==1){
                this.showDateTime=true;
        }else{
                this.showDateSelection=true;
                this.downSelection1=this.U_RangeTime;
        }
    },
    getQueryByTcode() {
      for (let i = 0; i < this.codeList.length; i++) {
        this.$api.getQueryByTcode({ tcode: this.codeList[i] })
          .then(Response => {
            console.log("字典表返回"+this.codeList[i],Response)
            switch (this.codeList[i]) {
              case "Classes"                 :  this.courseTypeList = Response.data;break;
              case "teacherType"             :  this.teacherTypeList = Response.data;break;
              case "StudentType"             :  this.studentTypeList = Response.data;break;
              case "Country"                 :  this.CountryList = Response.data;break; 
              case "CourseCity"              :  this.CourseCityList = Response.data;break;
              case "Currency"                :  this.CurrencyList = Response.data;break;
              case "U_RangeTime"             :  this.U_RangeTime = Response.data;break;
            }
          });
      }
    },
    // 查询导师
    getCourseTeacherInfo(ID){
      this.$api.getCourseTeacherInfo({salesId: this.$wxuserUtil.getUserId(),teacherType:ID}).then(Response=>{
           console.log("查询导师",Response)
           if(Response.success){
              for(let i=0;i<Response.data.length;i++){
                  Response.data[i]['value']= Response.data[i]['teacherId'];
              }
              this.supervisorList= Response.data;
           }
      })
    },
    getCourseDetails(ID,Page,courseId){
       let data={};
           data['salesId']=this.$wxuserUtil.getUserId();
           data['courseId']=courseId;
           data['pageNumber']=Page;
           data['pageSize']=this.pageSize;

       var  Response= this.$api.getCourseDetails(data)
            if(Response.success){
              console.log("ssss",Response)
              let result   =  Response.data;
              let courseModel  = result.courseModel;
               if(ID==1){
                    this.U_RangeTimeList=this.amendDataList(result.calendarList);
                    this.pullList[0]['name']=courseModel.name;
                    this.pullList[0]['value']=courseModel.name;
                    this.pullList[1]['name']=courseModel.type;
                    this.pullList[1]['value']=courseModel.typeDval;
                    this.pullList[2]['name']=courseModel.teacherType;
                    this.pullList[2]['value']=courseModel.teacherTypeDval;
                    this.pullList[3]['name']=courseModel.teacherName;
                    this.pullList[3]['value']=courseModel.teacherId;
                    this.pullList[4]['name']=courseModel.startDate;
                    this.pullList[5]['name']=courseModel.endDate;
                    this.pullList[6]['name']=courseModel.country;
                    this.pullList[6]['value']=courseModel.countryDval;
                    this.pullList[7]['name']=courseModel.city;
                    this.pullList[7]['value']=courseModel.cityDval;
                    this.pullList[8]['name']=courseModel.address;
                    this.pullList[8]['value']=courseModel.address;
                    this.pullList[9]['name']=courseModel.studentType;
                    this.pullList[9]['value']=courseModel.studentTypeDval;
                    this.pullList[10]['name']=courseModel.sudentCnt;
                    this.pullList[11]['value']=courseModel.currencyDval;
                    this.pullList[11]['name']=courseModel.currency;
                    this.pullList[12]['value']=courseModel.price;
                    this.pullList[12]['name']=courseModel.price;
                    this.pullList[13]['value']=courseModel.amount;
                    this.pullList[13]['name']=courseModel.amount;    
                    this.pullList[14]['value']=courseModel.neededShow;     
                     this.content=courseModel.descption;    
                     this.getCourseTeacherInfo(courseModel.teacherTypeDval)
                                            
               }
            }
    },
/**
 * 
 *   修改返回数据结构
 * 
 */
amendDataList(data){
  let $data=[];
   if(Array.isArray(data)){
       for(let i=0; i<data.length;i++){
          $data.push({"date":data[i]['date'],"timeFrame":data[i]['timeframeVal'],"courseCalendarId":data[i]['courseCalendarId'],deleteFlag:data[i]['deleteFlag'],})
       }

       return $data;
   }
},
   /**
    * 
    *   添加请选择
    * 
    */
   setCodeAlls(data){
      if(Array.isArray(data)){
        return  [{name:"请选择",value:""}].concat(data);  
      }else{
        return  [].concat(data);
      }
   },
   /**
    * 
    *   计算费用合计
    * 
    */
   totals(){
       console.log('人数',this.pullList[10]['name'])
       console.log('单人费用',this.pullList[12]['name'])
       if(this.pullList[10]['name']&&this.pullList[12]['name']){
         this.pullList[13]['name']= parseFloat( this.pullList[10]['name']*this.pullList[12]['name']).toFixed(2)
         this.pullList[13]['value']=parseFloat(this.pullList[10]['name']*this.pullList[12]['name']).toFixed(2)
       }
   },
   deletes(index){
         console.log(index)
         this.U_RangeTimeList.splice(index,1)
         this.MaxMin(this.U_RangeTimeList);
   },
   //修改的富文本
   onEditorChange(val){
     this.Qcontent=val.html;
   },
  // 返回上一级
  returnTo(){
    this.$router.push({ path: "/listCurriculum"})
  },    
  },
  mounted() {
     this.getQueryByTcode();
    if(this.$route.query.courseId){
         this.getCourseDetails(1,1,this.$route.query.courseId);
         this.courseId=this.$route.query.courseId;
    }
    if(this.$route.query.title){
      document.title=this.$route.query.title
    }
    document.getElementById('app').scrollTop =  0;
  },
  created() {
   $(":focus").blur()
  },
  watch: {},
  components: {}
};
</script>


<style lang="less" scoped   src="~p/pageView-filter.less"></style>  
<style lang="less" scoped>
.van-uploader{
      opacity: 0;
    height: 0.01rem;
}
.titles{
  color:#0d0d0d;
}
.delete-flex{
  width:.8rem;
  height: 100%;
  -ms-flex-item-align: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  line-height: 1.1rem;
}
.delete{
  width:.35rem;
  height:.35rem;
}
.center-flex{
  -ms-flex-item-align: center;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-size:.4rem;
}
.birthday-flex-style-one-ative{
  width:3.8rem;
}
.radio-flex{
  display: flex;
  flex-direction: row;
  justify-content:space-around;
  width:5rem;
  .neededShow-flex{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width:100%;
  }
}
.content {
  padding-bottom: 1rem;
  background: white;
  overflow: hidden;
}
.content_div {
  .van-field__label {
    width: 3rem;
  }
}

.group,
.radio_group {
  margin: 0.1rem auto;
  width: 95%;
  margin-bottom: 1rem;
  border: none;
  background: #fdfbfb;
  position: static;
  .van-cell {
    background: #fdfbfb;
  }
}
.radio_group-flex {
  margin-top: 0.15rem;
}
.content_div {
  margin-top: 0.15rem;
  padding: 0rem 0.3rem;
}
.botton_but {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.addbutton {
  width: 100%;
  display: block;
  margin: 0 auto;
  text-align: center;
  height: 1.2rem;
}
.genderRadio-flex {
  .van-radio-group {
    display: flex;
    width: 4rem;
    flex-direction: row;
    justify-content: space-between;
    //  margin: .5rem auto;
    font-size: 0.3rem;
  }
}
.content_div > li > .van-cell__right-icon {
  color: #c0c4cc;
  font-size: 14px;
  transition: transform 0.3s;
  transform: rotateZ(90deg);
  cursor: pointer;
}
.quillcontent {
  margin-bottom: 2rem;
}
.ql_editor {
  height: 100%;
  width: 95%;
  margin: 0 auto;
}
.van-cell__value {
  text-align: left;
  color: #323233;
}
.add-button {
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: bold;
  // color: #e10913;
  background: white;
  border: 1px solid #ffffff;
  border-radius: 0.1rem;
}
.delete {
}
.van-cell--required {
  background: rgb(246, 246, 246);
}
.van-cell-group-flex {
  height: 1.2rem;
  border: none;
  background: #fdfbfb;
  position: static;
  .van-cell {
    padding: 0.3rem 0.3rem;
    background: #fdfbfb;
    border: none;
  }
}
.rowcontent-item {
  -ms-flex-item-align: center;
  align-items: center;
  padding-left: 0.3rem;
}
.rowcontent {
  margin-top: 0.15rem;
  width: 100%;
  background: #fdfbfb;
  text-align: left;
  -ms-flex-item-align: center;
  align-items: center;
  height: 1rem;
  line-height: 1rem;
  font-size: 16px;
}
.downimg {
  position: absolute;
  right: 0.2rem;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: -0.6rem;
}
.downimgdate {
  width: 0.3rem;
  height: 0.3rem;
}
.rowinput {
  height: 0.9rem;
  background-color: #f6f6f6;
  color: rgba(13, 13, 13, 1);
  font-size: 14px;
  text-align: left;
  border: none;
}
.item-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  -ms-flex-item-align: center;
  align-items: center;
}
.returnTo{
  width:1rem;
  height:1rem;
  position:fixed;
  z-index: 10;
  bottom: 3rem;
  right: 0.3rem;
  background-color: #fff;
  border-radius: 50%;

  img{
    width:100%;
    height:100%;
    border-radius: 50%;
  }
}
.radio-flex{
  display: flex;
  flex-direction: row;
  justify-content:space-around;
  width:5rem;
  .neededShow-flex{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width:100%;
    .van-radio{
      padding-bottom: .1rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/lkcollege/addCurriculum.vue